(function (Rayban) {
  'use strict';

  var tooltips = [];

  var RBTooltip = function (trigger, settings) {
    if (! trigger) {
      throw new Error('Tooltip trigger not found');
    }
    this.trigger = trigger;

    if (settings) {
      this.settings = Rayban.utilities.extend(this.settings, settings);
    }
    this.init();
  };

  RBTooltip.prototype = {
    settings: {
      events: 'mouseover,mouseout',
      activeClass: 'active'
    },

    init: function () {
      this.tooltipSelector = this.trigger.getAttribute('href');
      this.tooltipDiv = this.getTooltipDiv();
      if (! this.tooltipDiv) {
        throw new Error('Tooltip not found: ' + this.tooltipSelector);
      }
      this.bind();
    },

    bind: function () {
      var self = this,
        events = self.settings.events.split(',');
      self.trigger.addEventListener('mouseover',
        function (e) {
          e.preventDefault();
          self.show();
        },
        false
      );

      self.trigger.addEventListener('mouseout',
        function (e) {
          e.preventDefault();
          self.hide();
        },
        false
      );
    },

    isVisible: function () {
      var style = window.getComputedStyle(this.tooltipDiv);
      return style.display !== 'none' && style.visibility !== 'hidden';
    },

    /** Searchs tooltip div by id or by class selector
     * @return {DOMElement}
     **/
    getTooltipDiv: function () {
      return document.querySelector(this.tooltipSelector);
    },

    show: function() {
      this.hideAll();
      this.tooltipDiv.classList.add(this.settings.activeClass);
    },

    hide: function () {
      this.tooltipDiv.classList.remove(this.settings.activeClass);
    },

    hideAll: function () {
      if (tooltips && tooltips.length) {
        for (var i = 0; i < tooltips.length; i += 1) {
          tooltips[i].hide();
        }
      }
    },

    toggle: function () {
      if (this.isVisible()) {
        this.hide();
      } else {
        this.show();
      }
    }

  };

  Rayban.RBTooltip = function (trigger, settings) {
    var t = new RBTooltip(trigger, settings);
    tooltips.push(t);
    trigger.RBTooltip = t;
  };


})(window.Rayban || {});

